var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xt-dialog',{attrs:{"visible":_vm.visible,"type":"alert","confirm-text":"确认"},on:{"confirm":_vm.close}},[_c('div',{staticStyle:{"text-align":"center","margin":"20px 0"}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }